import React, { useState, useEffect } from 'react';
import './Nav.css';
import img from '../../images/logotip.png';
import { Link, useLocation } from 'react-router-dom';

function Nav() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation(); 

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    useEffect(() => {
        setIsMenuOpen(false);
    }, [location]);

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    return (
        <>
            <nav className="navbar">
                <div className="logo">
                    <img src={img} alt="Логотип" />
                    <Link to='/'>МБОУ СШ №6 г. Павлово</Link>
                </div>

                <div className={`burger-menu ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
                    <div className="burger-line"></div>
                    <div className="burger-line"></div>
                    <div className="burger-line"></div>
                </div>

                <ul className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
                    <li><Link to={'/'} onClick={closeMenu}>Главная</Link></li>
                    <li><Link to={'/Choose_floor'} onClick={closeMenu}>Экскурсия</Link></li>
                    <li><Link to={'/About_school'} onClick={closeMenu}>История школы</Link></li>
                    <li><Link to={'/Contacts'} onClick={closeMenu}>Контакты</Link></li>
                </ul>
            </nav>
            <hr className='navsep'/>
        </>
    );
}

export default Nav;